import {ISalaryScheme, SalarySchemeResponseType} from "@/entity/salaryScheme/salaryScheme.types";
import {ISalarySchemeRepository} from "@/repository/salaryScheme/SalarySchemeRepository.types";
import Api from "@/repository/api";
import SalaryScheme from "@/entity/salaryScheme/salaryScheme";

export class SalarySchemeRepository implements ISalarySchemeRepository {
    async fetchAll(): Promise<ISalaryScheme[]> {
        const resp = await Api.get('/salary/scheme/get');
        const respData = resp.data as SalarySchemeResponseType[];
        return respData.map((el: SalarySchemeResponseType) => new SalaryScheme(el));
    }
}
